/**
 * Checks whether the current date is within a valid date range.
 * The range is considered active if:
 * - only startDate exists and is in the past or today
 * - only endDate exists and is in the future or today
 * - both dates exist and now is between them (inclusive)
 * - if startDate > endDate, it's considered invalid and returns false
 *
 * @param startDate optional string (ISO), Date, null or undefined
 * @param endDate optional string (ISO), Date, null or undefined
 * @param referenceDate optional string (ISO) or Date to check against; defaults to current date
 * @returns true if currently active; false otherwise
 */
export function isDateRangeActive(
  startDate?: string | Date | null,
  endDate?: string | Date | null,
  referenceDate?: string | Date | null
): boolean {
  const ref = referenceDate ? new Date(referenceDate) : new Date();
  if (isNaN(ref.getTime())) return false;


  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Consistency check: start must not be after end
    if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
      return false;
    }

    return start <= ref && end >= ref;
  }

  if (startDate && !endDate) {
    const start = new Date(startDate);
    return !isNaN(start.getTime()) && start <= ref;
  }

  if (!startDate && endDate) {
    const end = new Date(endDate);
    return !isNaN(end.getTime()) && end >= ref;
  }

  return false;
}
